interface WorkspaceTypeBadgeProps {
  type: "personal" | "team";
}

export function WorkspaceTypeBadge({ type }: WorkspaceTypeBadgeProps) {
  const badgeConfig = {
    personal: {
      label: "Personal",
      className: "bg-gray-200 text-gray-800 dark:bg-gray-700 dark:text-gray-300"
    },
    team: {
      label: "Team",
      className: "bg-gray-200 text-gray-800 dark:bg-gray-700 dark:text-gray-300"
    }
  };

  const config = badgeConfig[type];

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.className}`}
      data-testid={`workspace-type-badge-${type}`}
    >
      {config.label}
    </span>
  );
}